import React, { useContext } from 'react';
import { Box, Stack } from '@tonic-ui/react';
import { useTranslation } from 'react-i18next';
import { ServiceMatch } from './profiling-modal';
import ConfirmationModalTile from './confirmation-modal-tile';
import { AuthContext } from '../../../context/AuthContext';
import { actionDispatcher } from '../../../utils/ActionDispatchers';
import { sendEventTrack } from '../../../utils/helpers';

interface ConfirmationModalProps {
  matchedServices: ServiceMatch[];
}

const ConfirmationModal = ({ matchedServices }: ConfirmationModalProps): JSX.Element => {
  const { t } = useTranslation();
  const { eventDistributor } = useContext(AuthContext);

  const goToApp = (serviceName: string) => {
    if (serviceName === '') return;

    // Trigger custom track event for Pendo
    // Step 2 - user clicks on the service of their choice
    sendEventTrack('C1_PROFILE_QNS2', {
      Topic: 'SentryProfilingModal',
      Event: 'Sentry Profiling Service Selection',
      Indicator: 'User selected security service',
      UserResponse: `/${serviceName}`,
    });

    if (serviceName === 'conformity') {
      serviceName = serviceName + '/';
    }
    if (serviceName === 'workload') {
      serviceName = serviceName + '/Application.screen?';
    }
    return eventDistributor.dispatch(actionDispatcher('NAVIGATE_APP', 'appName', serviceName));
  };

  return (
    <Stack
      spacing="3x"
      marginTop="5x"
      data-id="onboarding-profiling-confirmation-modal"
      data-telemetry-id="onboarding-profiling-confirmation-modal"
    >
      {matchedServices?.length > 0 &&
        matchedServices.map(({ id, title, message }) => (
          <Box key={id}>
            <ConfirmationModalTile
              service={id}
              serviceTitle={t(title)}
              serviceMessage={t(message)}
              onClick={goToApp}
            />
          </Box>
        ))}
    </Stack>
  );
};

ConfirmationModal.displayName = 'ConfirmationModal';

export default ConfirmationModal;
